import { useEffect, useState, useCallback } from "react";
import { api, rupee } from "@/lib/api";
import { toast } from "sonner";

export default function EmiAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.get("/admin/emi").then((r) => setItems(r.data)).catch((e) => toast.error(e.response?.data?.detail || "Error")), []);
  useEffect(() => { load(); }, [load]);

  const toggleOverride = async (a) => {
    await api.put(`/admin/emi/${a.id}/override?allowed=${!a.allowed_new_purchase}`);
    toast.success(a.allowed_new_purchase ? "New purchases blocked" : "New purchases allowed");
    load();
  };

  return (
    <div>
      <h1 className="font-serif text-3xl mb-2">EMI Management</h1>
      <p className="text-xs text-[#8C867D] mb-6 uppercase tracking-widest">Customers paying via EMI · timeliness tracking</p>
      <div className="space-y-3">
        {items.length === 0 && <div className="admin-surface p-8 text-center text-sm text-[#8C867D]">No EMI plans yet.</div>}
        {items.map((a) => (
          <div key={a.id} className="admin-surface p-5" data-testid={`emi-row-${a.order_number}`}>
            <div className="flex flex-wrap justify-between gap-4 items-center">
              <div>
                <p className="font-medium">{a.customer_name || "—"} <span className="text-xs text-[#8C867D]">({a.customer_email})</span></p>
                <p className="font-mono text-xs text-[#8C867D] mt-1">{a.order_number}</p>
              </div>
              <div className="flex items-center gap-6 text-sm">
                <div className="text-center"><p className="text-xs text-[#8C867D]">Total</p><p>{rupee(a.total)}</p></div>
                <div className="text-center"><p className="text-xs text-[#8C867D]">Paid</p><p>{a.paid_count}/{a.months}</p></div>
                <div className="text-center"><p className="text-xs text-[#8C867D]">On-time</p><p className="text-[#C5A059]">{a.paid_count - a.late_count}</p></div>
                <div className="text-center"><p className="text-xs text-[#8C867D]">Late</p><p className={a.late_count ? "text-[#5B1C22]" : ""}>{a.late_count}</p></div>
                <div className="text-center"><p className="text-xs text-[#8C867D]">Overdue</p><p className={a.overdue_count ? "text-[#5B1C22]" : ""}>{a.overdue_count}</p></div>
                <span className={`text-[10px] uppercase tracking-widest px-2 py-1 ${a.status === "completed" ? "bg-[#C5A059] text-[#121212]" : "border border-[#27272A]"}`} data-testid={`emi-admin-status-${a.order_number}`}>{a.status}</span>
              </div>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2 text-xs" title="Allow this customer to buy new items while EMI is active">
                  <input type="checkbox" checked={!!a.allowed_new_purchase} onChange={() => toggleOverride(a)} data-testid={`emi-override-${a.order_number}`} /> Allow new purchase
                </label>
                <button onClick={() => setOpen(open === a.id ? null : a.id)} className="text-xs uppercase tracking-widest text-[#C5A059]" data-testid={`emi-expand-${a.order_number}`}>{open === a.id ? "Hide" : "Schedule"}</button>
              </div>
            </div>
            {open === a.id && (
              <div className="mt-4 pt-4 border-t border-[#27272A] flex flex-wrap gap-2">
                {a.installments.map((i) => (
                  <span key={i.n} className={`text-[10px] px-2 py-1 border ${i.paid ? (i.timely ? "border-[#C5A059] text-[#C5A059]" : "border-[#5B1C22] text-[#5B1C22]") : (new Date(i.due_date) < new Date() ? "border-[#5B1C22] text-[#5B1C22]" : "border-[#27272A] text-[#8C867D]")}`}>
                    #{i.n} {rupee(i.amount)} · {i.paid ? (i.timely ? "Paid on time" : "Paid late") : `Due ${new Date(i.due_date).toLocaleDateString("en-IN")}`}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
